/* eslint-disable complexity */
import { FeiertagEntry } from '@/domain/termine/features/Calendar/List/Feiertag/FeiertagEntry';
import { ListDayCell } from '@/domain/termine/features/Calendar/List/ListDayCell';
import { renderDayHeader } from '@/domain/termine/features/Calendar/List/ListDayHeader';
import { useCalendarContext } from '@/domain/termine/features/Calendar/shared/CalendarContext';
import { Day } from '@/domain/termine/type';
import dayjs from 'dayjs';
import { useCallback, useRef } from 'react';
import { useParams } from 'react-router-dom';

interface ListDayProps {
  day: Day;
  week: Day[];
  currentMonth: number;
  currentYear: number;
}

export function ListDay({ day, week }: ListDayProps) {
  const { feiertage, termineByDay } = useCalendarContext();
  const { year, month, day: routeDay } = useParams();
  const today = dayjs().startOf('day').locale('de');

  const isToday = day.isSame(today, 'day');
  const isTodayInWeek = week.some((d) => d.isSame(today, 'day'));
  const termineForDay = termineByDay.get(day.format('YYYY-MM-DD')) ?? [];
  const isTodayTermin = termineForDay.length > 0;
  const hasFeiertag = feiertage.some((f) => dayjs(f.datum).isSame(day, 'day'));

  const showHeader =
    hasFeiertag ||
    termineForDay.length > 0 ||
    (isToday && isTodayInWeek && !isTodayTermin);

  const hasScrolledRef = useRef(false);
  const routeDate = `${year}-${month?.padStart(2, '0')}-${routeDay?.padStart(2, '0')}`;
  const scrollToDate = day.isSame(routeDate, 'day')
    ? day.format('YYYY-MM-DD')
    : undefined;

  const shouldScroll = scrollToDate && !hasScrolledRef.current;
  const scrollRef = useCallback(
    (element: HTMLDivElement | null) => {
      if (element && shouldScroll) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        hasScrolledRef.current = true;
      }
    },
    [shouldScroll],
  );

  return (
    <div key={day.format('DD-MM-YYYY')} data-date={routeDate} ref={scrollRef}>
      {renderDayHeader(day, isToday, showHeader)}
      <FeiertagEntry day={day} />
      <ListDayCell
        day={day}
        termineForDay={termineForDay}
        isToday={isToday}
        hasFeiertag={hasFeiertag}
        isTodayInWeek={isTodayInWeek}
        isTodayTermin={isTodayTermin}
      />
    </div>
  );
}
